// src/pages/platformorder/LinkStockInstance.js
import React, { useState, useRef, useEffect } from 'react';
import { Info, Copy, Link as LinkIcon, X, ChevronsUpDown, SquareArrowOutUpRight, ChevronUp, ChevronDown, Search, Funnel, ChevronRight, ChevronLeft } from 'lucide-react';
import { useHistory, useLocation } from "react-router-dom";
import Tooltip from '../addentities/Tooltip.js';

const dummyData = [
    {
        id: 1,
        name: '2508040JSM0PRY',
        orderDate: '2025-01-23 12:30',
        platform: 'Shopee SG',
        platformStatus: 'To Ship',
        itemsCount: 5,
        orderTotal: 'SGD 1,433.27',
        finalTotal: '',
        linkage: 'Not linked (n)',
        listings: [
            {
                id: 'L-S1',
                listingName: 'Samsung Galaxy Z Fold 7\nSnapdragon 8 Elite | Z Fold 6 | Z Fold 5 | 5G | 256GB 512GB 1TB | 1 Year Samsung SG Warranty',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Z Fold 7 12GB 512GB, Blue Shadow',
                qty: 1,
                unitPrice: 'SGD 1,498.00',
                mappedStock: 'Samsung Galaxy Z Fold 7',
                mappedStockSku: 'SKU: 12GB 512GB,Blue Shadow',
                mappedStockBadges: ['New'],
                mappedStockBadgesRight: ['Unactivated'],
                stockInstance: '35334107 123456 2',
                stockInstanceLocation: 'Bedok',
                stockInstanceDate: '2025-01-23 12:30',
                instanceQty: 1,
                instanceStatus: 'Outbounding',
                rowBg: 'normal',
            },
            {
                id: 'L-S2',
                listingName: 'Mister Mobile Mercury Goospery Phone Case',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Clear',
                qty: 1,
                unitPrice: 'SGD 1,498.00',
                mappedStock: 'Stock not found please map it to a stock in Listing',
                mappedStockSku: '',
                mappedStockBadges: [],
                stockInstance: '',
                stockInstanceLocation: '',
                stockInstanceDate: '',
                instanceQty: "",
                instanceStatus: '',
                rowBg: 'stockout',
            },
            {
                id: 'L-S3',
                listingName: 'Mister Mobile Tempered Glass/Screen Protector',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Screen Protector, Samsung (All Models)',
                qty: 1,
                unitPrice: 'SGD 1,498.00',
                mappedStock: 'Mister Mobile Tempered Glass/Screen Protector',
                mappedStockSku: 'SKU: Screen Protector,Samsung (All Models)',
                mappedStockBadges: ['New'],
                mappedStockBadgesRight: ['Unactivated'],
                stockInstance: '',
                stockInstanceLocation: '',
                stockInstanceDate: '',
                instanceQty: "",
                instanceStatus: '',
                rowBg: 'normal',
            },
            {
                id: 'L-S4',
                listingName: 'Mister Mobile Mascot Cable Protector',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Clear',
                qty: 1,
                unitPrice: 'SGD 0',
                mappedStock: 'Mister Mobile Mascot Cable Protector',
                mappedStockSku: 'SKU: Clear',
                mappedStockBadges: ['New'],
                mappedStockBadgesRight: ['Unactivated'],
                stockInstance: '',
                stockInstanceLocation: '',
                stockInstanceDate: '',
                instanceQty: "",
                instanceStatus: '',
                rowBg: 'normal',
            },
            {
                id: 'L-S5',
                listingName: 'Samsung 25W USB-C Power Adapter Singapore',
                avatar: 'https://rukminim2.flixcart.com/image/704/844/xif0q/mobile/3/5/l/-original-imaghx9qmgqsk9s4.jpeg?q=90&crop=false',
                variation: 'Adapter (Black), Original',
                qty: 1,
                unitPrice: 'SGD 16.00',
                mappedStock: 'Samsung 25W USB-C Power Adapter Singapore',
                mappedStockSku: 'SKU: Adapter (Black),Original',
                mappedStockBadges: ['New'],
                mappedStockBadgesRight: ['Unactivated'],
                stockInstance: '',
                stockInstanceLocation: '',
                stockInstanceDate: '',
                instanceQty: "",
                instanceStatus: '',
                rowBg: 'normal',
            },
        ]
    }
];

function copyToClipboard(text) {
    if (!text) return;
    try { navigator.clipboard.writeText(text); } catch (err) { /* ignore */ }
}

export default function LinkStockInstance() {
    const history = useHistory();
    const location = useLocation();

    const breadcrumbs = ["Order", "Platform Order", "Link Stock Instance"];

    // main listing state (left table)
    const [listingsState, setListingsState] = useState(
        Array.isArray(dummyData) && dummyData.length ? dummyData[0].listings : []
    );

    const saveRef = useRef(null);
    const [saveModalOpen, setSaveModalOpen] = useState(false);
    useEffect(() => {
        function handleClickOutside(event) {
            if (saveRef.current && !saveRef.current.contains(event.target)) {
                setSaveModalOpen(false);
            }
        }
        if (saveModalOpen) document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [saveModalOpen]);

    // Modal context: which listing are we linking
    const [modalListingId, setModalListingId] = useState(null);

    // Simple search input for modal
    const [imeiSearchInput, setImeiSearchInput] = useState('');

    // Sample IMEI/Stock instances (the modal table). In a real app this comes from API.
    const sampleImeiRows = [
        { id: 1, imei: '35334107 123456 2', branch: 'Bedok', qty: 1, firstStockInTime: '2025-01-23 12:30', stockOut: 1 },
        { id: 2, imei: '35334107 123456 3', branch: 'Bedok', qty: 1, firstStockInTime: '2025-01-23 12:30', stockOut: 0 },
        { id: 3, imei: '35334107 123456 4', branch: 'HQ', qty: 1, firstStockInTime: '2025-01-23 12:30', stockOut: 0 },
        { id: 4, imei: '35334107 123456 5', branch: 'HQ', qty: 1, firstStockInTime: '2025-01-23 12:30', stockOut: 0 },
        { id: 5, imei: '35334107 123456 6', branch: 'HQ', qty: 1, firstStockInTime: '2025-01-23 12:30', stockOut: 0 },
    ];

    // Modal state: which sample row is selected (single-select). Also per-row qty state.
    const [selectedInstanceId, setSelectedInstanceId] = useState(null);
    const [instanceQtys, setInstanceQtys] = useState({}); // { id: qty }

    // --- add near other states (e.g. after instanceQtys) ---
    const [stockOuts, setStockOuts] = useState(
        () => Object.fromEntries(sampleImeiRows.map(r => [r.id, Number(r.stockOut) || 0]))
    );


    // Simple stats for modal (kept static from sample, could be computed)
    const imeiStats = {
        reserved: 2,
        available: 8,
        pendingTotals: { Outbound: { count: 1, color: '#ffb703' }, Return: { count: 0, color: '#6c757d' } }
    };

    // Open modal for a particular listing id
    function openModalForListing(listingId) {
        setModalListingId(listingId);

        const listing = listingsState.find(l => l.id === listingId);

        if (listing && listing.stockInstance) {
            // match by exact imei text
            const matched = sampleImeiRows.find(r => r.imei === listing.stockInstance);
            if (matched) {
                setSelectedInstanceId(matched.id);
                setInstanceQtys(prev => ({ ...prev, [matched.id]: listing.instanceQty || matched.qty || 1 }));
            } else {
                setSelectedInstanceId(null);
            }
        } else {
            setSelectedInstanceId(null);
        }

        setImeiSearchInput('');
        setSaveModalOpen(true);
    }

    // Confirm selection from modal -> update listing row
    function confirmModalSelection() {
        if (!modalListingId) {
            setSaveModalOpen(false);
            return;
        }
        const selectedRow = sampleImeiRows.find(r => r.id === selectedInstanceId);

        setListingsState(prev =>
            prev.map(l => {
                if (l.id !== modalListingId) return l;
                if (!selectedRow) {
                    // clear existing link
                    return {
                        ...l,
                        stockInstance: '',
                        stockInstanceLocation: '',
                        stockInstanceDate: '',
                        instanceQty: '',
                        instanceStatus: '',
                        stockOut: undefined
                    };
                }

                const qty = Number(instanceQtys[selectedRow.id] ?? selectedRow.qty ?? 1);
                const stockOutVal = Number(stockOuts[selectedRow.id] ?? selectedRow.stockOut ?? 0);

                return {
                    ...l,
                    stockInstance: selectedRow.imei,
                    stockInstanceLocation: selectedRow.branch,
                    stockInstanceDate: selectedRow.firstStockInTime,
                    instanceQty: qty,
                    stockOut: stockOutVal,
                    // example textual status (optional)
                    instanceStatus: stockOutVal ? `Stock Out: ${stockOutVal}` : 'Reserved'
                };
            })
        );

        setSaveModalOpen(false);
        setModalListingId(null);
    }

    // toggle selected instance (single-select)
    function toggleSelectInstance(rowId) {
        if (selectedInstanceId === rowId) {
            setSelectedInstanceId(null);
        } else {
            setSelectedInstanceId(rowId);
            setInstanceQtys(prev => ({ ...prev, [rowId]: prev[rowId] ?? 1 }));
        }
    }

    // change qty for an imei row
    function changeInstanceQty(rowId, value) {
        const val = Math.max(0, Number(value || 0));
        setInstanceQtys(prev => ({ ...prev, [rowId]: val }));
    }

    function changeStockOut(rowId, value) {
        const val = Math.max(0, Number(value || 0));
        setStockOuts(prev => ({ ...prev, [rowId]: val }));
    }


    // computed visible rows according to search
    const filteredImeiRows = sampleImeiRows.filter(r =>
        r.imei.toLowerCase().includes(imeiSearchInput.toLowerCase())
        || r.branch.toLowerCase().includes(imeiSearchInput.toLowerCase())
    );

    // modal pagination (10 rows per page to match main table)
    const [modalPage, setModalPage] = useState(1);
    const MODAL_PER_PAGE = 10;

    // modal pagination math
    const modalTotal = filteredImeiRows.length;
    const totalPages = Math.max(1, Math.ceil(modalTotal / MODAL_PER_PAGE));
    const modalStartIndex = (modalPage - 1) * MODAL_PER_PAGE;
    const modalEndIndexExclusive = modalStartIndex + MODAL_PER_PAGE;
    const paginatedImeiRows = filteredImeiRows.slice(modalStartIndex, modalEndIndexExclusive);

    // showing text values
    const showingFrom = modalTotal === 0 ? 0 : modalStartIndex + 1;
    const showingTo = Math.min(modalStartIndex + paginatedImeiRows.length, modalTotal);

    // whenever the search/filter changes, reset to page 1
    useEffect(() => {
        setModalPage(1);
    }, [imeiSearchInput]);


    const modalListing = listingsState.find(l => l.id === modalListingId);




    return (
        <div className="company-body main-company-body-inner new-look bulk-pricing-root">
            <div className="breadcrumb">
                {breadcrumbs.map((crumb, index) => {
                    const isLast = index === breadcrumbs.length - 1;
                    return (
                        <span
                            key={index}
                            className={`breadcrumb-item ${crumb === "Platform Order" ? "clickable" : ""}`}
                            onClick={() => { if (crumb === "Platform Order") history.push('/platform-order'); }}
                            style={{ cursor: crumb === "Platform Order" ? 'pointer' : 'default' }}
                        >
                            {crumb}{!isLast ? '  ' : ''}
                        </span>
                    );
                })}
            </div>

            <div className='edit-organisation-info'>
                <div className='edit-organisation-left'>
                    <h1>Link Stock Instance <Tooltip content="Link Stock Instance"><Info size={16} className="info-icon" /></Tooltip></h1>
                </div>

                <div className='discard-save-organisation-right d-flex align-items-center justify-content-end flex-wrap gap-2'>
                    <button className="dark-button" type='button'>Cancel</button>
                    <button className="dark-border" type="button" onClick={(e) => { e.stopPropagation(); history.push('/platform-order-linked'); }}>Save</button>
                </div>
            </div>

            <div className="employee-tabs-container">
                <div className="tab-content" id="edit-spu-content">
                    <div className="info-section">
                        <div className="info-card new-info-overflow-auto">
                            <div className="info-header"><h4 className="info-title">Settlement</h4></div>
                            <div className="info-content d-block">
                                <div className='grid-info-adding'>
                                    <div className='row gappingcls-added'>
                                        <div className='col-lg-6 col-md-6 col-12'>
                                            <div className="info-inner">
                                                <label htmlFor="id" className="form-label d-flex align-items-center gap-1">Final Total <span className="error-color">*</span>
                                                    <Tooltip content="Final Total"><Info size={16} className="info-icon" /></Tooltip>
                                                </label>
                                                <div style={{ display: 'inline-flex', alignItems: 'center', border: '1px solid #6C757D', borderRadius: 8, minWidth: 210, overflow: 'hidden', width: "100%" }}>
                                                    <div style={{ color: '#6C757D', fontWeight: 400, fontSize: 14, padding: '10px 14px' }}>SGD</div>
                                                    <input
                                                        className="form-control" defaultValue="178.00"
                                                        style={{ border: 'none', outline: 'none', boxShadow: 'none', minWidth: 150, textAlign: 'left', borderLeft: '1px solid #6C757D', borderRadius: 0 }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="info-card new-info-overflow-auto main-company-body-inner">
                            <div className="info-header"><h4 className="info-title">Link Instance</h4></div>
                            <div className="info-content d-block entities-tab">
                                <div style={{ padding: '20px', boxShadow: '0px 1px 4px #0000001A', borderRadius: '12px' }}>
                                    <div className="table-wrapper" style={{ position: 'relative', overflowX: 'auto' }}>
                                        <table className="entities-table accordion-table" style={{ width: '100%', borderCollapse: 'collapse', minWidth: '700px' }}>
                                            <colgroup>
                                                <col style={{ width: '36%' }} />
                                                <col style={{ width: '4%' }} />
                                                <col style={{ width: '28%' }} />
                                                <col style={{ width: '28%' }} />
                                                <col style={{ width: '4%' }} />
                                            </colgroup>
                                            <thead>
                                                <tr style={{ background: '#e9ecef' }}>
                                                    <th style={{ background: '#e9ecef', padding: '15px 12px', textAlign: 'left', fontWeight: 700 }}>Listing Name</th>
                                                    <th style={{ background: '#e9ecef', padding: '15px 12px', textAlign: 'left', fontWeight: 700 }}>Qty</th>
                                                    <th style={{ background: '#e9ecef', padding: '15px 12px', textAlign: 'left', fontWeight: 700 }}>Stock</th>
                                                    <th style={{ background: '#e9ecef', padding: '15px 12px', textAlign: 'left', fontWeight: 700 }}>Stock Instance</th>
                                                    <th style={{ background: '#e9ecef', padding: '15px 12px', textAlign: 'left', fontWeight: 700 }}>Qty</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {Array.isArray(listingsState) && listingsState.length > 0 ? (
                                                    listingsState.map(listing => (
                                                        <tr
                                                            key={listing.id}
                                                            className={`listing-row ${listing.rowBg === 'stockout' ? 'stockout' : ''}`}
                                                            style={{ background: listing.rowBg === 'stockout' ? '#FEF1F1' : '#ffffff' }}
                                                        >
                                                            <td style={{ padding: '10px 12px', verticalAlign: 'middle', border: 0 }}>
                                                                <div style={{ display: 'flex', gap: 12 }}>
                                                                    <img
                                                                        src={listing.avatar || ''}
                                                                        alt=""
                                                                        className="avatar"
                                                                        style={{ width: 32, height: 32, objectFit: 'cover', borderRadius: 6, flex: 'none' }}
                                                                    />
                                                                    <div style={{ whiteSpace: 'pre-line' }}>
                                                                        <div>{listing.listingName}</div>
                                                                        <div style={{ fontSize: 10, color: '#6C757D', marginTop: 4 }}>{`Variation: ${listing.variation}`}</div>
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td style={{ padding: '10px 12px', textAlign: 'left', verticalAlign: 'middle', border: 0 }}>{listing.qty}</td>

                                                            <td style={{ padding: '10px 12px', verticalAlign: 'middle', border: 0, whiteSpace: "normal" }}>
                                                                {listing.rowBg === 'stockout' ? (
                                                                    <div style={{ fontWeight: 600, color: '#58151C' }}>{listing.mappedStock}</div>
                                                                ) : (
                                                                    <>
                                                                        <div>{listing.mappedStock}</div>
                                                                        {listing.mappedStockSku && (
                                                                            <div style={{ fontSize: 10, color: '#6C757D', marginTop: 4 }}>{listing.mappedStockSku}</div>
                                                                        )}
                                                                        {(Array.isArray(listing.mappedStockBadges) && listing.mappedStockBadges.length > 0) ||
                                                                            (Array.isArray(listing.mappedStockBadgesRight) && listing.mappedStockBadgesRight.length > 0) ? (
                                                                            <div style={{ marginTop: 4, display: 'flex', alignItems: 'center', gap: 6 }}>
                                                                                {listing.mappedStockBadges?.map((b, i) => (
                                                                                    <span key={`left-${i}`} style={{
                                                                                        fontSize: 8, fontWeight: 600, lineHeight: "normal",
                                                                                        padding: '2px 8px', background: '#D1E7DD', borderRadius: 99,
                                                                                        color: '#198754', border: '1px solid #198754'
                                                                                    }}>{b}</span>
                                                                                ))}

                                                                                {listing.mappedStockBadgesRight?.map((b, i) => (
                                                                                    <span key={`right-${i}`} style={{ fontSize: 10, color: "#6C757D" }}>{b}</span>
                                                                                ))}
                                                                            </div>
                                                                        ) : null}
                                                                    </>
                                                                )}
                                                            </td>

                                                            <td style={{ padding: '10px 12px', verticalAlign: 'middle', border: 0 }}>
                                                                {listing.stockInstance ? (
                                                                    <div>
                                                                        <div style={{ color: '#0D6EFD', cursor: 'pointer', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}>
                                                                            <span onClick={() => copyToClipboard(listing.stockInstance)} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                                                                                {listing.stockInstance}
                                                                            </span>
                                                                            <Copy size={13} onClick={() => copyToClipboard(listing.stockInstance)} style={{ cursor: 'pointer', color: '#0D6EFD' }} />
                                                                        </div>
                                                                        <div style={{ fontSize: 10, color: '#6C757D', marginTop: 4 }}>{listing.stockInstanceLocation}</div>
                                                                        <div style={{ fontSize: 10, color: '#6C757D', marginTop: 2 }}>{listing.stockInstanceDate}</div>
                                                                        <div style={{ marginTop: 12 }}>
                                                                            <button
                                                                                className="relink-btn"
                                                                                style={{
                                                                                    borderRadius: 8, padding: '8px 12px', border: '1px solid #212529', background: '#fff',
                                                                                    cursor: 'pointer', boxShadow: '0px 1px 4px 0px #0000001A;', color: '#212529', fontSize: 12, fontWeight: 600
                                                                                }}
                                                                                onClick={() => openModalForListing(listing.id)}
                                                                            >
                                                                                <LinkIcon size={18} style={{ marginRight: 6 }} /> Re-Link
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div>
                                                                        {listing.rowBg === 'stockout' ? (
                                                                            <button className="link-btn disabled" disabled style={{ borderRadius: 8, padding: '8px 12px', border: '1px solid #ADB5BD', background: '#E9ECEF', boxShadow: '0px 1px 4px 0px #0000001A;', color: '#ADB5BD', fontSize: 12, fontWeight: 600 }}>
                                                                                <LinkIcon size={18} style={{ marginRight: 6 }} /> Link
                                                                            </button>
                                                                        ) : (
                                                                            <button
                                                                                type="button"
                                                                                className="link-btn as"
                                                                                style={{ borderRadius: 8, padding: '8px 12px', border: '1px solid #212529', background: '#fff', cursor: 'pointer', boxShadow: '0px 1px 4px 0px #0000001A;', color: '#212529', fontSize: 12, fontWeight: 600 }}
                                                                                onClick={() => openModalForListing(listing.id)}
                                                                            >
                                                                                <LinkIcon size={18} style={{ marginRight: 6 }} /> Link
                                                                            </button>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </td>

                                                            <td style={{ padding: '10px 12px', textAlign: 'left', verticalAlign: 'middle', border: 0 }}>
                                                                {listing.stockOut !== undefined && listing.stockOut !== '' ? listing.stockOut : listing.instanceQty}
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={5} style={{ padding: 12, color: '#212529', border: 0 }}>No listings for this order</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {saveModalOpen && (
                            <>
                                <div className="drawer-overlay" />
                                <div
                                    className="entity-drawer modal-popup-cls"
                                    ref={saveRef}
                                    style={{
                                        maxWidth: 900,
                                        margin: "0 auto",
                                        background: "white",
                                        borderRadius: 12,
                                        zIndex: 1050,
                                        padding: 24,
                                        position: "fixed",
                                        top: "50%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
                                        height: "auto",
                                        right: "auto",
                                        overflow: "inherit",
                                    }}
                                >
                                    <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
                                        <button className="close-btn" onClick={() => setSaveModalOpen(false)}>
                                            <X size={20} />
                                        </button>
                                    </div>
                                    <h3 style={{ textAlign: "left", color: "#212529", fontSize: "20px", fontWeight: "600", lineHeight: "24px", fontFamily: "Montserrat", marginBottom: "5px" }}>Select Stock Instance</h3>
                                    <div className='entities-tab' style={{ padding: 0, paddingTop: '20px' }}>
                                        <div className="toolbar">
                                            <div className="toolbar-left">
                                                <div className="search-box">
                                                    <Search size={16} />
                                                    <input
                                                        type="text"
                                                        placeholder="Search…"
                                                        value={imeiSearchInput}
                                                        onChange={e => setImeiSearchInput(e.target.value)}
                                                        style={{ border: 'none', outline: 'none', marginLeft: 8 }}
                                                    />
                                                </div>
                                                <button className="icon-btn" onClick={() => { /* open filters */ }}>
                                                    <Funnel size={16} /> Filter
                                                </button>
                                            </div>
                                        </div>

                                        <div className='table-wrapper' style={{ marginTop: 16 }}>
                                            <table className="entities-table" style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                <thead>
                                                    <tr style={{ background: '#f8f9fa' }}>
                                                        <th style={{ padding: 10 }}>Select</th>
                                                        <th style={{ padding: 10 }}>IMEI/Barcode <ChevronsUpDown size={12} /></th>
                                                        <th style={{ padding: 10 }}>Branch <ChevronsUpDown size={12} /></th>
                                                        <th style={{ padding: 10, textAlign: 'center' }}>Qty <ChevronsUpDown size={12} /></th>
                                                        <th style={{ padding: 10 }}>First Stock In Time <ChevronsUpDown size={12} /></th>
                                                        <th style={{ padding: 10 }}>Stock Out <ChevronsUpDown size={12} /></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {paginatedImeiRows.length > 0 ? paginatedImeiRows.map((row, idx) => (
                                                        <tr key={row.id} className={((modalStartIndex + idx) % 2 === 1) ? 'striped' : ''}>
                                                            <td style={{ padding: 10 }}>
                                                                <div className="form-check" onClick={e => e.stopPropagation()}>
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={selectedInstanceId === row.id}
                                                                        onChange={() => toggleSelectInstance(row.id)}
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td className='py-3' style={{ padding: 10 }}>
                                                                <a
                                                                    href="#"
                                                                    onClick={e => e.preventDefault()}
                                                                    className="d-flex align-items-center gap-1 me-3"
                                                                    style={{ color: '#0D6EFD', cursor: 'pointer', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8 }}
                                                                >
                                                                    <span onClick={() => copyToClipboard(row.imei)} style={{ textDecoration: 'underline', cursor: 'pointer' }}>
                                                                        {row.imei}</span>
                                                                    <Copy size={13} onClick={() => copyToClipboard(row.imei)} style={{ cursor: 'pointer', color: '#0D6EFD' }} />
                                                                </a>
                                                            </td>
                                                            <td style={{ padding: 10 }}>{row.branch}</td>
                                                            <td style={{ padding: 10, textAlign: 'center' }}>
                                                                {/* show the qty from the listing being edited (modalListing) if available,
      otherwise fallback to the sample row's qty */}
                                                                {modalListing ? modalListing.qty : row.qty}
                                                            </td>
                                                            <td style={{ padding: 10 }}>{row.firstStockInTime}</td>
                                                            <td style={{ padding: 10 }}>
                                                                <div style={{ position: 'relative', width: 84 }}>
                                                                    <input
                                                                        type="number"
                                                                        min={0}
                                                                        value={stockOuts[row.id] ?? row.stockOut}
                                                                        onChange={e => changeStockOut(row.id, e.target.value)}
                                                                        disabled={selectedInstanceId !== row.id}
                                                                        style={{
                                                                            width: '100%',
                                                                            padding: '9px 36px 9px 10px', // space on right for buttons
                                                                            borderRadius: 8,
                                                                            border: '1px solid #CED4DA',
                                                                            boxSizing: 'border-box',
                                                                            textAlign: 'center',
                                                                            fontSize: 14,
                                                                            color: '#6C757D',
                                                                            background: selectedInstanceId !== row.id ? '#E9ECEF' : undefined
                                                                        }}
                                                                    />

                                                                    {/* internal up/down inside the input */}
                                                                    <div style={{
                                                                        position: 'absolute',
                                                                        right: 6,
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        display: 'flex',
                                                                        flexDirection: 'column',
                                                                        pointerEvents: 'auto'
                                                                    }}>
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => changeStockOut(row.id, (Number(stockOuts[row.id] ?? row.stockOut) || 0) + 1)}
                                                                            disabled={selectedInstanceId !== row.id}
                                                                            style={{ border: 'none', background: 'transparent', padding: 2, cursor: selectedInstanceId !== row.id ? 'not-allowed' : 'pointer' }}
                                                                            aria-label="increase"
                                                                        >
                                                                            <ChevronUp size={16} style={{ color: '#6C757D', strokeWidth: 3 }} />
                                                                        </button>

                                                                        <button
                                                                            type="button"
                                                                            onClick={() => changeStockOut(row.id, Math.max(0, (Number(stockOuts[row.id] ?? row.stockOut) || 0) - 1))}
                                                                            disabled={selectedInstanceId !== row.id}
                                                                            style={{ border: 'none', background: 'transparent', padding: 2, cursor: selectedInstanceId !== row.id ? 'not-allowed' : 'pointer' }}
                                                                            aria-label="decrease"
                                                                        >
                                                                            <ChevronDown size={16} style={{ color: '#6C757D', strokeWidth: 3 }} />
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </td>

                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan={6} className="py-3 text-center">No results found.</td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                        {/* modal pagination (same style as main table) */}
                                        <div className="pagination" style={{ paddingBottom: 14, borderBottom: '1px solid #DEE2E6' }}>
                                            <div className="pagination-info">
                                                {`Showing ${showingFrom} - ${showingTo} of ${modalTotal} items`}
                                            </div>

                                            <div className="pagination-controls">
                                                <button
                                                    onClick={() => setModalPage(p => Math.max(1, p - 1))}
                                                    disabled={modalPage === 1}
                                                >
                                                    <ChevronLeft size={20} />
                                                </button>

                                                {[...Array(totalPages)].map((_, i) => (
                                                    <button
                                                        key={i}
                                                        className={modalPage === i + 1 ? 'active' : ''}
                                                        onClick={() => setModalPage(i + 1)}
                                                    >
                                                        {i + 1}
                                                    </button>
                                                ))}
                                                <button
                                                    onClick={() => setModalPage(p => Math.min(totalPages, p + 1))}
                                                    disabled={modalPage === totalPages}
                                                >
                                                    <ChevronRight size={20} />
                                                </button>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="drawer-footer" style={{ paddingTop: "10px", display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                        <button className="btn-cancel" onClick={() => { setSaveModalOpen(false); }}>
                                            Cancel
                                        </button>
                                        <button className="btn-save" onClick={confirmModalSelection}>
                                            Confirm
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}